<template>
  <card :padding="24" dis-hover class="profile-block-card system-settings">
    <div class="card-header large">
      <div class="card-header__title">
        <icon class="ms-help" size="16" type="ios-cog"></icon>
        <span class="ms-help card-header__title-text">Настройки системы</span>
      </div>
    </div>
    <div class="system-settings__block">
      <div class="system-settings__block-title ms-small-head">
        Цветовая тема интерфейса
      </div>
      <div class="system-settings__block-content">
        <radio-group v-model="theme" size="default" type="button">
          <radio label="Темная" />
          <radio label="Светлая" />
        </radio-group>
      </div>
    </div>
  </card>
</template>

<script>
import { toggleTheme } from '@/utils'

export default {
  computed: {
    theme: {
      get () {
        return this.$store.state.theme === 'dark' ? 'Темная' : 'Светлая'
      },
      set (value) {
        const theme = value === 'Темная' ? 'dark' : 'light'
        toggleTheme(theme)
        this.$store.commit('SET_THEME', theme)
      }
    }
  }
}
</script>

<style lang="less">
  .system-settings {
    &__block {
      &-title {
        margin-bottom: 8px;
      }
    }
  }
</style>
